import React, { useState } from 'react';
import { Stack } from '@mui/material';
import { Add } from '@mui/icons-material';
import AddUserProject from './AddUserProject';
import ActionButton from '../../../ui/primitives/ActionButton';

const ProjectTableAction = ({ fetchProjectData }) => {
  const [open, setOpen] = useState(false);
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <ActionButton
        intent="primary"
        icon={<Add />}
        label="Add New Project"
        onClick={() => setOpen(true)}
      />
      <AddUserProject fetchProjectData={fetchProjectData} setOpen={setOpen} open={open} />
    </Stack>
  );
};

export default ProjectTableAction;
